export default __webpack_public_path__ + "static/media/hht2_ep_07.9f615139.png";